import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { UAParser } from 'ua-parser-js';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Parses a user agent string into a more readable format.
 * @param uaString The raw user agent string from the audit log.
 * @returns A formatted string like "Chrome 125 on Windows 11" or "N/A".
 */
/**
 * Formats a date string into a short, readable format.
 * @param dateString The ISO date string to format.
 * @returns A formatted string like "Jan 15, 2025".
 */
export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function parseUserAgent(uaString: string | null | undefined): string {
  if (!uaString) {
    return 'N/A';
  }

  const parser = new UAParser(uaString);
  const browser = parser.getBrowser();
  const os = parser.getOS();

  let result = '';
  if (browser.name) {
    result += `${browser.name}${browser.version ? ` ${browser.version}` : ''}`;
  }
  if (os.name) {
    result += `${result ? ' on ' : ''}${os.name}${os.version ? ` ${os.version}` : ''}`;
  }

  return result || 'Unknown';
}
